import React, { useEffect, useContext, useState } from 'react';
import { Spin, Tree, Empty } from 'antd';
import { AiOutlineFolder } from 'react-icons/ai';
import { FiHardDrive } from 'react-icons/fi';
import { useFileExploreContext } from 'hooks/useFileExplore';
import LocaleContext from 'locales';

const { DirectoryTree } = Tree;

export default function NavigationPane() {
  const { state, handleTreeSelect, handleTreeExpand, handleLoadData } = useFileExploreContext();

  const { folders, selectedKeys, expandedKeys, loadedKeys, loading } = state;

  const [treeHeight, setTreeHeight] = useState(window.innerHeight - 200);
  const { locale } = useContext(LocaleContext);

  // 창 크기 변경 감지를 위함
  useEffect(() => {
    const handleResize = () => {
      setTreeHeight(window.innerHeight - 200);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const renderTreeIcon = (treeNode) => {
    const iconStyle = {
      fontSize: '18px',
      position: 'relative',
      top: '3px',
      marginRight: treeNode.driveId ? '16px' : '10px',
    };
    return treeNode.driveId ? (
      <FiHardDrive style={iconStyle} />
    ) : (
      <AiOutlineFolder style={iconStyle} />
    );
  };

  // 트리 데이터 로딩 여부 확인
  const hasTreeData = folders && folders.length > 0;

  return (
    <div
      className="navigation-pane"
      style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
    >
      <Spin spinning={loading} style={{ flex: 1, overflowY: 'auto', height: '100%' }}>
        {!hasTreeData ? (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={locale.resource['txt.file-transfer.no-folder']}
          />
        ) : (
          <div style={{ padding: '5px 0' }}>
            <DirectoryTree
              height={treeHeight} // 동적으로 창 높이에 맞게 설정
              treeData={folders}
              selectedKeys={selectedKeys}
              expandedKeys={expandedKeys}
              loadedKeys={loadedKeys} // 데이터가 이미 로드된 폴더 키 배열
              onSelect={handleTreeSelect}
              onExpand={handleTreeExpand}
              loadData={handleLoadData} // 폴더 확장 시 비동기 데이터 로딩을 위한 함수
              icon={renderTreeIcon}
              defaultExpandAll={false} // 초기 렌더링 시 모든 폴더 확장 여부
              autoExpandParent={false} // 자식 폴더가 선택/확장될 때 부모 폴더 자동 확장 여부
              blockNode
              expandAction={false} // 폴더 선택 시 자동 확장/축소 여부
              fieldNames={{
                title: 'title',
                key: 'key',
                children: 'children',
              }}
              titleRender={(nodeData) => (
                <span
                  style={{
                    fontWeight: nodeData.driveId ? 'bold' : 'normal',
                    lineHeight: nodeData.driveId ? '19px' : '18px',
                    display: 'inline-block',
                    paddingTop: '3px',
                    paddingBottom: '4px',
                    maxWidth: '170px',
                  }}
                >
                  {nodeData.title}
                </span>
              )}
            />
          </div>
        )}
      </Spin>
    </div>
  );
}
